import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Box from '@mui/material/Box';
import SmoothScroll from './providers/SmoothScroll';
import Landing from './modules/Landing';
import Couple from './modules/couple/Couple';
import Navbar from './modules/navbar/Navbar';
import Footer from './modules/footer/Footer';
import AdminRsvp from './modules/rsvp/AdminRsvp';
import MusicPlayer from './modules/common/MusicPlayer';

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
      <SmoothScroll>
      <Navbar />

      <Routes>
        {/* Page unique : toutes les sections défilent sur l'accueil */}
        <Route path="/" element={<Landing />} />

        {/* Anciennes routes → redirigées vers la page unique */}
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/story" element={<Navigate to="/" replace />} />
        <Route path="/where-when" element={<Navigate to="/" replace />} />
        <Route path="/gallery" element={<Navigate to="/" replace />} />
        <Route path="/rsvp" element={<Navigate to="/" replace />} />

        {/* Pages à part (marge sous la navbar fixe) */}
        <Route
          path="/admin/rsvp"
          element={<Box sx={{ pt: "60px" }}><AdminRsvp /></Box>}
        />
        <Route
          path="/couple"
          element={<Box sx={{ pt: "60px" }}><Couple /></Box>}
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
      <MusicPlayer />
      </SmoothScroll>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
